/**
 * Entry of dist/assistant.js: a tiny, dependency-free loader that installs window.AICommerce,
 * renders the launcher inside a Shadow DOM and lazily loads the React panel chunk
 * (dist/assistant-panel.js) on first interaction.
 */
import { createSdk, VERSION } from './sdk';
import { resolveLocalesUrl, resolvePanelUrl, scriptPanelLoader } from './panelLoader';
import { needsLocalePack, resolveLocale } from '../shared/locale';
import { loadState } from '../shared/storage';
import { startMeasurement } from './measurement';

const currentSrc = typeof document !== 'undefined' ? (document.currentScript as HTMLScriptElement | null)?.src : undefined;

if (typeof window !== 'undefined' && !(window.AICommerce && window.AICommerce.version)) {
  window.AICommerce = createSdk({
    panelLoader: (config) => {
      const panelUrl = resolvePanelUrl(currentSrc, config.panelUrl);
      // de/fr/es storefronts: the panel dictionaries come from assistant-locales.js, fetched alongside the panel
      return scriptPanelLoader(panelUrl, () => (needsLocalePack(resolveLocale(config.locale, loadState(config.tenantKey).tenant_locale)) ? resolveLocalesUrl(panelUrl) : null));
    },
    // holdout + `widget_eligible` + consent-gated `aca_vid` (CONTRACTS §J.2)
    measurement: (config, hooks) => startMeasurement(config, hooks),
  });
  window.dispatchEvent(new CustomEvent('aicommerce:loaded', { detail: { version: VERSION } }));
}
